import { Delete } from '@mui/icons-material';
import { Button } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteButton } from '~/components/button';
import { Dialog, DialogContentTitle, DialogTitle } from './components';
import { DialogActions, DialogContent } from './lib/styles';

export interface ConfirmDialogProps {
  readonly cancel?: string;
  readonly confirm?: string;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
  readonly open: boolean;
  readonly prompt?: ReactNode;
  readonly title?: string;
  readonly confirmButton?: JSX.Element;
  readonly deleteConfirm?: boolean; // indicates if it's a delete confirmation dialog or not - if so we tweak the style a bit
  readonly deleteIcon?: ReactNode; // icon to use for delete confirmation
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { t } = useTranslation();
  const {
    open,
    onConfirm,
    onCancel,
    confirmButton,
    deleteConfirm = false,
    deleteIcon = <Delete />,
  } = props;

  const {
    cancel = t('common.dialogs.cancel'),
    confirm = t('common.dialogs.confirm'),
    prompt = t('common.dialogs.confirm_prompt'),
    title = t('common.dialogs.confirm_title'),
  } = props;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onCancel}>
      <DialogTitle onClose={onCancel}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentTitle>{prompt}</DialogContentTitle>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          {cancel}
        </Button>
        {deleteConfirm ? (
          <DeleteButton startIcon={deleteIcon} variant="contained" onClick={onConfirm}>
            {confirm}
          </DeleteButton>
        ) : confirmButton ? (
          confirmButton
        ) : (
          <Button variant="contained" onClick={onConfirm} color="primary">
            {confirm}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
